import { tokenGetCode } from "@/api/user";
const personalUrl = process.env.VUE_APP_PERSONAL_URL;
import store from "@/store";

export const isWechatBrowser = () => {
  const ua = navigator.userAgent.toLowerCase();
  return ua.indexOf("micromessenger") != -1;
};

export const setTitle = (title) => {
  document.title = title;
  var i = document.createElement("iframe");
  i.style.display = "none";
  i.onload = function () {
    setTimeout(function () {
      i.remove();
    }, 9);
  };
  document.body.appendChild(i);
};

export function deepCopy(currentObj) {
  let newObj = Array.isArray(currentObj) ? [] : {}; //Step#1
  for (let key in currentObj) {
    //Step#2
    let property = currentObj[key];
    if (typeof property === "object") {
      newObj[key] = deepCopy(property); //Step#3
    } else {
      newObj[key] = property; //Step#3
    }
  }
  return newObj;
}

export const generateSharelink = (link, origin) => {
  let _link = link;
  // 没_origin参数 拼上参数
  if (!link.includes("_origin")) {
    if (link.includes("?")) {
      _link = `${_link}&_origin=${origin}`;
    } else {
      _link = `${_link}?_origin=${origin}`;
    }
  }

  return _link;
};

// 防抖
export function debounce(fn, delay) {
  // fn 是函数调用时的第一个函数参数
  let timer = null;
  return function (...args) {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
}

export const formatTime2 = (date) => {
  return date.replace(/-/g, "/");
};

export const isMobileDevice = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|OperaMini/i.test(
    navigator.userAgent,
  );
};

export const isMobileClient = () => {
  return window.document.body.clientWidth - 1 < 1200;
};

// 获取当前网站的子域名
export function extractMeetingId(url = location.href) {
  // 使用正则表达式匹配meeting后面的数字
  var match = url.match(/meeting(\d+)/);
  if (match && match[1]) {
    // 如果匹配成功，返回提取的数字部分
    return match[1];
  } else {
    // 如果匹配失败，返回null或者其他适当的值
    return null;
  }
}

// 获取主机名
export function getHostname(url = location.href) {
  // 创建 URL 对象
  var parsedUrl = new URL(url);
  // 返回主机名部分
  return parsedUrl.hostname;
}

// 获取主题大写来源
export const getBigOrigin = () => {
  const id = store.getters["config/getPlatformId"];
  return id ? `CONFERENCE_ID_${id}` : "";
};

// 获取主题小写来源
const getOrigin = () => {
  const id = store.getters["config/getPlatformId"];
  return id ? `conference_id_${id}` : "";
};

// 去个人中心通用大会支付页面
export const toMyCenterMeetingPay = (code, orderId, backurl) => {
  const myCenter =
    personalUrl +
    "/auth?type=commonmeetingpay&origin=" +
    getOrigin() +
    "&code=" +
    code +
    "&orderId=" +
    orderId +
    "&_back_url=" +
    backurl;
  location.assign(myCenter);
};

// 下载
export function download(name, url) {
  const fileExtension =
    name.split(".").pop().toLowerCase() || url.split(".").pop().toLowerCase();
  // 根据文件后缀名判断文件类型
  if (fileExtension === "pdf") {
    // 如果是 PDF 文件，打开新窗口预览
    window.open(url, "_blank");
  } else if (fileExtension === "doc" || fileExtension === "docx") {
    // 如果是 DOC 或 DOCX 文件，进行下载
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", name);
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } else {
    // 其他类型的文件，您可以自定义处理方式
    alert("不支持的文件类型，请下载。");
  }
}

// 	PC去play页面
export const toPcPlay = async (id) => {
  const token = localStorage.getItem("token")
    ? localStorage.getItem("token")
    : "";
  let code = "";
  if (token) {
    const { results } = await tokenGetCode();
    code = results;
  }
  window.open(
    `${
      process.env.VUE_APP_PERSONAL_URL_PC
    }/auth?columnId=${id}&source=${getBigOrigin()}&type=play&code=${code}`,
    "_blank",
  );
};

// h5去play页面
export const toH5Play = async (id) => {
  const token = localStorage.getItem("token")
    ? localStorage.getItem("token")
    : "";
  let code = "";
  if (token) {
    const { results } = await tokenGetCode();
    code = results;
  }
  const play =
    personalUrl +
    "/auth?type=play" +
    "&origin=" +
    getOrigin() +
    "&code=" +
    code +
    "&id=" +
    id +
    "&theme=" +
    getOrigin();
  location.assign(play);
};

// pc跳转
export const pcToLink = async (url) => {
  // try {
  //   const domain = url.split(".")[1];
  //   const token = localStorage.getItem("token");
  //   if (!token && domain === "morehealth") {
  //     store.commit("user/setPcLoginPop", true);
  //     return;
  //   }
  //   const link = new URL(url);
  //   let outlink = "";
  //   const source = getBigOrigin();
  //   const { results: code } = await tokenGetCode();
  //   const backurl = location.href;
  //   if (link.search) {
  //     outlink =
  //       url + "&source=" + source + "&code=" + code + "&_back_url=" + backurl;
  //   } else {
  //     outlink =
  //       url + "?source=" + source + "&code=" + code + "&_back_url=" + backurl;
  //   }
  //   window.open(outlink, "_blank");
  // } catch (error) {
  window.open(url, "_blank");
  // }
};

// h5跳转
export const h5ToLink = async (url) => {
  try {
    const domain = url.split(".")[1];
    const token = localStorage.getItem("token");
    const link = new URL(url);
    let outlink = "";
    const source = getBigOrigin();
    let code;
    if (domain == "morehealth" && token) {
      const { results } = await tokenGetCode();
      code = results;
    }
    const backurl = location.href;
    if (link.search) {
      outlink =
        url +
        "&source=" +
        source +
        (code ? "&code=" + code : "") +
        "&_back_url=" +
        backurl;
    } else {
      outlink =
        url +
        "?source=" +
        source +
        (code ? "&code=" + code : "") +
        "&_back_url=" +
        backurl;
    }
    location.assign(outlink);
  } catch (error) {
    location.assign(url);
  }
};

// 去YMCenter通用大会授权页面
export const toYMCenterMeetingPayAuth = async (
  code,
  appId,
  source,
  bigOrigin,
  orderId,
  backurl,
) => {
  // 拼接微信授权 重定向 到个人中心WechatAuth 需要的参数  bigOrigin orderId  backurl
  const params = `_code=${code}&_big_origin=${bigOrigin}&orderId=${orderId}&_return_url=${backurl}`;
  const wechat_redirect = encodeURIComponent(
    `${process.env.VUE_APP_YM_CENTER_WECHATAUTH}?${params}`,
  );
  location.replace(
    `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${wechat_redirect}&response_type=code&scope=snsapi_userinfo&state=${source}#wechat_redirect`,
  );
};

/**
 * 窗口大小变化检测函数
 * @param {Function} callback - 窗口大小变化时执行的回调函数
 * @param {number} [delay=200] - 防抖延迟时间(毫秒)
 * @returns {Function} 取消监听的函数
 */
export const onWindowResize = (callback, delay = 200) => {
  // 存储上一次的窗口尺寸
  let lastWidth = window.innerWidth;
  let lastHeight = window.innerHeight;

  // 防抖计时器
  let resizeTimer = null;

  // 实际的处理函数
  const handleResize = () => {
    const currentWidth = window.innerWidth;
    const currentHeight = window.innerHeight;

    // 只有当宽度或高度真正改变时才调用回调
    if (currentWidth !== lastWidth || currentHeight !== lastHeight) {
      const oldWidth = lastWidth;
      const oldHeight = lastHeight;
      callback({
        width: currentWidth,
        height: currentHeight,
        oldWidth,
        oldHeight,
      });

      // 再更新记录
      lastWidth = currentWidth;
      lastHeight = currentHeight;
    }
  };

  // 防抖处理后的函数
  const debouncedHandler = () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(handleResize, delay);
  };

  // 添加事件监听
  window.addEventListener("resize", debouncedHandler);

  // 返回一个取消监听的函数
  return () => {
    window.removeEventListener("resize", debouncedHandler);
    clearTimeout(resizeTimer);
  };
};

export function downloadByUrl({ url, target = "_blank", fileName }) {
  if (!url) return;

  if (/(iP)/g.test(navigator.userAgent)) {
    console.error("Your browser does not support download!");
    return false;
  }

  const link = document.createElement("a");
  link.href = url;
  link.target = target;

  link.download = fileName || url.substring(url.lastIndexOf("/") + 1);

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  return true;
}
